import { render, staticRenderFns } from "./VeGiaoThongForm.vue?vue&type=template&id=3ba8ceb6"
import script from "./VeGiaoThongForm.vue?vue&type=script&lang=js"
export * from "./VeGiaoThongForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports